import React from 'react';

import { SvgComponent } from '@/types/modules/svg.types';

export const ArrowLeftLong: SvgComponent = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d="M2.75 12C2.75 11.4477 3.19772 11 3.75 11H20.25C20.8023 11 21.25 11.4477 21.25 12C21.25 12.5523 20.8023 13 20.25 13H3.75C3.19772 13 2.75 12.5523 2.75 12Z" fill="currentColor"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M11.2071 4.54289C11.5976 4.93342 11.5976 5.56658 11.2071 5.95711L5.16421 12L11.2071 18.0429C11.5976 18.4334 11.5976 19.0666 11.2071 19.4571C10.8166 19.8476 10.1834 19.8476 9.79289 19.4571L3.04289 12.7071C2.65237 12.3166 2.65237 11.6834 3.04289 11.2929L9.79289 4.54289C10.1834 4.15237 10.8166 4.15237 11.2071 4.54289Z" fill="currentColor"/>
	</svg>
);
